import type { Dispatch, ReactNode } from 'react';

import type { LANGUAGES } from '@crehana/ts-types';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import type { CuiOptionType } from '@crehana/ui';

export enum ACTIONS {
  NAVIGATE = 'NAVIGATE',
  SET_FIRST_PAGE = 'SET_FIRST_PAGE',
  SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS',
  SET_THIRD_PAGE = 'SET_THIRD_PAGE',
  SET_LICENCE_NUMBER = 'SET_LICENCE_NUMBER',
  SET_TOTAL_PRICE = 'SET_TOTAL_PRICE',
}

interface NAVIGATE_ACTION {
  type: ACTIONS.NAVIGATE;
  payload: 1 | 2 | 3 | 4;
}
export interface BaseCountry extends CuiOptionType<string> {
  id: number;
}

export type CountryType = BaseCountry | undefined;
interface SET_ACCOUNT_DETAILS_ACTION {
  type: ACTIONS.SET_ACCOUNT_DETAILS;
  payload: {
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    company: string;
    phoneNumber: {
      code: string;
      phoneNumber: string;
    };
    country: CountryType;
    docNroCompany: string;
    opportunityId?: string;
  } | null;
}

interface SET_LICENCE_NUMBER_ACTION {
  type: ACTIONS.SET_LICENCE_NUMBER;
  payload: number;
}

interface SET_TOTAL_PRICE_ACTION {
  type: ACTIONS.SET_TOTAL_PRICE;
  payload: number;
}

export type ActionType =
  | NAVIGATE_ACTION
  | SET_ACCOUNT_DETAILS_ACTION
  | SET_LICENCE_NUMBER_ACTION
  | SET_TOTAL_PRICE_ACTION;

export interface StripeContextProps {
  stripe: stripe.Stripe | null;
}

export interface StripeProviderProps {
  children: ReactNode;
  language: LANGUAGES;
}

export interface InitialStateType {
  currentStep: number;
  licences: number;
  accountDetails: {
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    company: string;
    phoneNumber: {
      code: string;
      phoneNumber: string;
    };
    country: CountryType;
    opportunityId?: string;
    docNroCompany: string;
  } | null;
  totalPrice: number;
}

export interface CheckoutContextValues {
  state: InitialStateType;
  dispatch: Dispatch<ActionType>;
  ONBOARDING_STEPS: {
    id: number;
    label: string;
  }[];
  pricePerSeat: number;
  loading: boolean;
  currency: string;
  productName: string;
  productId: string;
}
